export default function YesNoToggle({ label, value, onChange }) {
  return (
    <div className="flex items-center gap-3">

      <span className="text-sm font-light">{label}</span>

      <span
        className={`text-xs font-semibold ${
          !value ? "text-black" : "text-gray-400"
        }`}
      >
        NO
      </span>

      <div
        onClick={onChange}
        className="w-12 h-5 bg-neutral-200 rounded-full relative cursor-pointer transition-all duration-300"
      >
        <div
          className={`w-5 h-5 rounded-full absolute top-0 transition-all duration-300 shadow-sm ${
            value ? "right-0 bg-zinc-700" : "left-0 bg-zinc-500"
          }`}
        />
      </div>

      <span
        className={`text-xs font-semibold ${
          value ? "text-black" : "text-gray-400"
        }`}
      >
        YES
      </span>

    </div>
  );
}